import {qboFinanceView} from './QboFinanceModel';
const reports=new WeakMap();
// A report is immutable application input. New source/projection revisions arrive
// as new response objects. Keep only a few derived views of each retained report.
export function memoAccountingView(report,options,owner){
 if(!report||typeof report!=='object')return null;
 let views=reports.get(report);if(!views){views=new Map();reports.set(report,views);}
 const key=JSON.stringify([owner,report.companyIds,options.view,options.metric,options.interval,options.lines,options.selection?.preset,options.selection?.start,options.selection?.end,options.preview,report.revision,report.projectionRevision,report.end]);
 const hit=views.get(key);if(hit&&hit.mini===options.mini)return hit.value;
 const value=qboFinanceView(report,options);views.set(key,{mini:options.mini,value});if(views.size>30)views.delete(views.keys().next().value);return value;
}
